import { formatDate } from '@angular/common';
import { CategoryListItem } from '../../../../../pages/admin-dashboard/categories/category.model';
import { CategoryTableRow } from './category-table-component.model';

function toCategoryTableRow(
  category: CategoryListItem,
  index: number,
  isArabic: boolean,
  locale: string,
): CategoryTableRow {
  // The list API returns no modification date, so "last updated" mirrors the creation date.
  const date = category.createdOn ? formatDate(category.createdOn, 'mediumDate', locale) : '—';

  return {
    id: category.id,
    index,
    name: (isArabic ? category.titleAr : category.titleEn) || category.titleEn,
    dateCreated: date,
    lastUpdated: date,
  };
}

export function toCategoryTableRows(
  categories: CategoryListItem[],
  isArabic: boolean,
  locale: string,
  firstIndex = 1,
): CategoryTableRow[] {
  return categories.map((c, i) => toCategoryTableRow(c, firstIndex + i, isArabic, locale));
}
